import "./OrdersStats.css";

import {
  MdShoppingBag,
  MdPendingActions,
  MdRestaurant,
  MdDeliveryDining,
  MdCheckCircle,
} from "react-icons/md";

function OrdersStats({ orders = [] }) {

  const total = orders.length;

  const pending = orders.filter(
    (o) => o.status === "Pending"
  ).length;

  const accepted = orders.filter(
    (o) => o.status === "Accepted"
  ).length;

  const preparing = orders.filter(
    (o) => o.status === "Preparing"
  ).length;

  const delivered = orders.filter(
    (o) => o.status === "Delivered"
  ).length;

  const cards = [
    {
      title: "Total Orders",
      value: total,
      icon: <MdShoppingBag />,
      className: "total",
    },
    {
      title: "Pending",
      value: pending,
      icon: <MdPendingActions />,
      className: "pending",
    },
    {
      title: "Preparing",
      value: preparing,
      icon: <MdRestaurant />,
      className: "preparing",
    },
    {
      title: "Accepted",
      value: accepted,
      icon: <MdDeliveryDining />,
      className: "accepted",
    },
    {
      title: "Delivered",
      value: delivered,
      icon: <MdCheckCircle />,
      className: "delivered",
    },
  ];

  return (
    <div className="orders-stats">

      {cards.map((card, index) => (

        <div
          className={`orders-stat-card ${card.className}`}
          key={index}
        >

          <div className="orders-stat-icon">
            {card.icon}
          </div>

          <div className="orders-stat-content">

            <h4>{card.title}</h4>

            <h2>{card.value}</h2>

          </div>

        </div>

      ))}

    </div>
  );
}

export default OrdersStats;